import { useState } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import UserRolesTab from './UserRolesTab';
import ZoneManagementTab from './ZoneManagementTab';
import TeamManagementTab from './TeamManagementTab';
import ExportAuditTab from './ExportAuditTab';

const TABS = [
    { key: 'userRoles', label: 'User Roles & Access' },
    { key: 'zones', label: 'Zone Management' },
    { key: 'teams', label: 'Team Management' },
    { key: 'export', label: 'Export & Audit' },
];

export default function AdminSettings() {
    const decode = useCurrentUser();
    const isAdmin = decode?.role === 'admin';
    const [activeTabKey, setActiveTabKey] = useState(TABS[0].key);

    if (!isAdmin) return null;

    return (
        <div style={{ width: '100%', backgroundColor: 'white', minHeight: '100vh' }}>
            <Box sx={{ padding: '24px' }}>
                <h2>Admin Settings — RBAC Management</h2>
                <Tabs value={activeTabKey} onChange={(e, value) => setActiveTabKey(value)}>
                    {TABS.map((tab) => (
                        <Tab key={tab.key} value={tab.key} label={tab.label} disableRipple />
                    ))}
                </Tabs>
                <Box sx={{ padding: '24px 0' }}>
                    {activeTabKey === 'userRoles' && <UserRolesTab />}
                    {activeTabKey === 'zones' && <ZoneManagementTab />}
                    {activeTabKey === 'teams' && <TeamManagementTab />}
                    {activeTabKey === 'export' && <ExportAuditTab />}
                </Box>
            </Box>
        </div>
    );
}
